import {
  BoxGeometry,
  Group,
  Mesh,
  MeshStandardMaterial,
  SphereGeometry,
} from "three";

function proxyMaterial(id: string): MeshStandardMaterial {
  const material = new MeshStandardMaterial({ color: 0x087a86, roughness: 0.82 });
  material.name = id;
  material.userData.materialId = id;
  return material;
}

export function createFirstYardWorkSphereProxy(): Group {
  const root = new Group();
  root.name = "first-yard-work-sphere-proxy";
  root.userData.assetNodeId = "first-yard-work-sphere-root";
  const geometry = new SphereGeometry(1, 16, 12);
  geometry.clearGroups();
  const mesh = new Mesh(geometry, proxyMaterial("first-yard-work-sphere-material"));
  mesh.name = "first-yard-work-sphere-volume";
  mesh.userData.assetNodeId = "first-yard-work-sphere-volume";
  root.add(mesh);
  return root;
}

export function createFirstYardPurchaseBoxProxy(): Group {
  const root = new Group();
  root.name = "first-yard-purchase-box-proxy";
  root.userData.assetNodeId = "first-yard-purchase-box-root";
  const geometry = new BoxGeometry(1.5, 1, 1.5);
  geometry.clearGroups();
  const mesh = new Mesh(geometry, proxyMaterial("first-yard-purchase-box-material"));
  mesh.name = "first-yard-purchase-box-volume";
  mesh.position.y = 0.5;
  mesh.userData.assetNodeId = "first-yard-purchase-box-volume";
  root.add(mesh);
  return root;
}
